import React from 'react'
import moment from 'moment'

import { Expansible } from 'components/Expansible'
import {
  BGC_FIELDS,
  getBgcVariableTitle,
  SCORE_PARTICIPANTS,
} from 'utils/constants/bgcFields'
import { AccessTime, Cancel, CheckCircle } from '@mui/icons-material'
import _ from 'lodash'
import styles from './styles'
import BuildCompanyData from './BuildCompanyData'
import BuildFamilyRelations from './BuildFamilyRelations'
import BuildProcesses from './BuildProcesses'
import BuildRestrictions from './BuildRestrictions'
import BuildPep from './BuildPep'
import BuildNegativeMedia from './BuildNegativeMedia'
import BuildFinancialSituation from './BuildFinancialSituation'
import BuildComplianceList from './BuildComplianceList'
import BuildFrontierZone from './BuildFrontierZone'

const BgcExpansible = ({
  field,
  bgc_info,
  score_data,
  processed,
  consists,
}) => {
  const classes = styles()

  const renderScore = () => {
    const score = score_data && score_data.value ? score_data.value : 0
    const pointWord = score === 1 ? 'ponto' : 'pontos'
    const reason = score_data && score_data.reason ? score_data.reason : ''

    return <div className={classes.score}>
      {(SCORE_PARTICIPANTS.includes(field) && !_.isEmpty(reason)) && (
        <div>
          <p>
            <strong>Pontuação parcial: </strong>
            {`${score} ${pointWord}`}
          </p>
          <p>
            <strong>Motivo: </strong>
            {reason}
          </p>
        </div>
      )}

      <span>
        <strong>Última atualização: </strong>{' '}
        {bgc_info?.updated
          ? moment(bgc_info?.updated).format('DD/MM/YYYY HH:mm')
          : 'N/A'}
      </span>
    </div>
  }

  const fieldComponentMapping = {
    [BGC_FIELDS.negative_media]: { component: BuildNegativeMedia, props: { negativeMediaData: bgc_info } },
    [BGC_FIELDS.pep]: { component: BuildPep, props: { pepData: bgc_info } },
    [BGC_FIELDS.restriction_data]: { component: BuildRestrictions, props: { restrictionsData: bgc_info } },
    [BGC_FIELDS.process_data]: { component: BuildProcesses, props: { processData: bgc_info } },
    [BGC_FIELDS.family_relation_data]: { component: BuildFamilyRelations, props: { familyRelationsData: bgc_info } },
    [BGC_FIELDS.company_data]: { component: BuildCompanyData, props: { companyData: bgc_info } },
    [BGC_FIELDS.compliance_list]: { component: BuildComplianceList, props: { complianceListData: bgc_info } },
    [BGC_FIELDS.frontier_zone]: { component: BuildFrontierZone, props: { frontierZoneData: bgc_info } },
    [BGC_FIELDS.financial_situation]: { component: BuildFinancialSituation, props: { financial_situation: bgc_info } },
  }

  const itemTitleAndStatus = () => {
    return (
      <span className={classes.itemTitleAndStatusSpan}>
        {!processed && <AccessTime className={classes.icon} />}
        {processed &&
          (consists ? (
            <Cancel className={classes.reprovedIcon} />
          ) : (
            <CheckCircle className={classes.icon}></CheckCircle>
          ))}

        {getBgcVariableTitle(field)}
      </span>
    )
  }

  const renderContent = () =>
    bgc_info || field === BGC_FIELDS.compliance_list ? (
      <div
        className={
          field === BGC_FIELDS.negative_media ? classes.midia : classes.info
        }
      >
        {Object.keys(fieldComponentMapping).includes(field) &&
          fieldComponentMapping[field].component(
            fieldComponentMapping[field].props,
          )}

        {renderScore()}
      </div>
    ) : (
      <div className={classes.expansibleContent}>
        <span>Nenhuma informação encontrada.</span>
      </div>
    )

  const renderProcessing = () => (
    <div className={classes.expansibleContent}>
      <span>
        O Background Check ainda não terminou de processar este tema. Por favor
        aguarde.
      </span>
    </div>
  )

  return (
    <Expansible open={false} title={itemTitleAndStatus()}>
      {processed ? renderContent() : renderProcessing()}
    </Expansible>
  )
}

export default BgcExpansible
